import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Overview',
  name: 'lineOverview',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Features',
      name: 'features',
      type: 'array',
      of: [
        {
          type: 'string',
        },
      ],
    }),
    defineField({
      title: 'Wheel Carousel',
      name: 'carousel',
      type: 'wheelLandingCarousel',
    }),
  ],
})